import { shallowEqual } from "react-redux";

export function findIndexShallowEqual<T>(
  array: T[],
  item: T,
): number {
  return array.findIndex((value) => shallowEqual(value, item));
}